var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleLeftArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.113,
    height: 9,
    viewBox: "0 0 9.113 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "double-left-arrow-icon",
    transform: "translate(-4.311 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M8.292,14a.646.646,0,0,1-.456-.188L4.877,10.864a1.924,1.924,0,0,1,0-2.727L7.836,5.188a.644.644,0,1,1,.912.909L5.787,9.046a.641.641,0,0,0,0,.909L8.745,12.9A.643.643,0,0,1,8.292,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M15,14a.646.646,0,0,1-.456-.188l-3.87-3.857a.641.641,0,0,1,0-.909l3.87-3.857a.644.644,0,1,1,.912.909L12.042,9.5l3.414,3.4A.643.643,0,0,1,15,14Z",
    transform: "translate(-2.222 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeftArrowIcon);
export default __webpack_public_path__ + "static/media/double-left-arrow-icon.c5b53f236a99158c03f4f25cad519e06.svg";
export { ForwardRef as ReactComponent };